import * as React from 'react';

const SvgIconRadioButtonLarge = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("circle", { className: "fi-icon-radio-base", cx: 15, cy: 15, r: 14.5 }),
        React.createElement("circle", { className: "fi-icon-radio-checked", cx: 15, cy: 15, r: 8 }))));

export { SvgIconRadioButtonLarge as default };
//# sourceMappingURL=IconRadioButtonLarge.js.map
